<app-loader *ngIf="isDisabled"></app-loader>
<!-- <div class="row g-0">
    <div class="col-md-5">
        <div class="card">
            <div class="card-body p-1">
                <div class="row">
                    <label class="form-label"
                        style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;text-align: -webkit-center;">Online
                        Attendance</label>
                </div>
                <div class="row">
                    <label class="form-label"
                        style="font-size: 25px!important;font-weight: 500; margin-bottom: 5px;text-align: -webkit-center;">{{Duration}}</label>
                </div>
                <div style="background-color:#80808036;border-radius: 5px;" class="p-2 mb-2">
                    <div class="row" *ngIf="AttendanceDetail.EmpType == 'FRONT'">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Branch</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.BranchName}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Site</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.SiteName}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Designation</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.DesignationName}}</label>
                        </div>
                    </div>
                    <div class="row" *ngIf="AttendanceDetail.EmpType == 'FRONT'">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Duty</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.DutyName}}</label>
                        </div>
                    </div>
                    <div class="row" *ngIf="AttendanceDetail.EmpType == 'FRONT'">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Shift</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.ShiftTitle}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">In
                                Date Time</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.InTime??'00:00:00'
                                | date: 'dd-MMM-yyyy H:mm:ss'}}</label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">Out
                                Date Time</label>
                        </div>
                        <div class="col-auto">
                            <label class="form-label"
                                style="font-size: 13px!important;font-weight: 500; margin-bottom: 5px;color: #191d4a;">{{AttendanceDetail.OutTime??'00:00:00'
                                | date: 'dd-MMM-yyyy H:mm:ss'}}</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 d-grid" *ngIf="!isDisabled">
                        <button class="btn btn-primary"
                            *ngIf="!AttendanceDetail.IsCheckIn && !AttendanceDetail.IsAttendaceClose" mat-raised-button
                            color="primary" type="button" (click)="GetDateTime(true)"
                            [disabled]="AttendanceDetail.IsAttendaceClose || isDisabled"><i
                                class="bi bi-box-arrow-in-right me-2"></i>Check
                            In</button>
                        <button class="btn btn-danger"
                            *ngIf="AttendanceDetail.IsCheckIn && !AttendanceDetail.IsAttendaceClose" mat-raised-button
                            color="warn" type="button" (click)="GetDateTime(true)"
                            [disabled]="AttendanceDetail.IsAttendaceClose || isDisabled"><i
                                class="bi bi-box-arrow-in-left me-2"></i>Check Out</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->

<div class="card border-radius-0 m-1 p-0">
    <div class="card-header">
        <div class="card-title">
            Attendance History
        </div>
    </div>
    <div class="card-body">
        <form class="g-3" name="filterForm" (ngSubmit)="Validate(filterForm)" #filterForm="ngForm" novalidate>
            <div class="row pb-2">
                <div class="col-md-3">
                    <label for="FromDate" class="text-label-dark">From Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="FromDate"
                            [(ngModel)]="Filter.FromDate" ngbDatepicker #FromDate="ngbDatepicker" readonly required
                            (ngModelChange)="Clear()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
                            type="button"></button>
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="ToDate" class="text-label-dark">To Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="DD MMM YYYY" name="ToDate" [(ngModel)]="Filter.ToDate"
                            ngbDatepicker #ToDate="ngbDatepicker" readonly required (ngModelChange)="Clear()" />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
                            type="button"></button>
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="ApprovalStatus" class="form-font-label">Status</label>
                    <select class="form-select" aria-label="ApprovalStatus" placeholder="Status" title="Status"
                        name="Status" data-live-search="true" [(ngModel)]="Filter.ApprovalStatus"
                        #ApprovalStatus="ngModel" required required (change)="Clear()">
                        @for (status of common.Status; track status.Value; let i = $index) {
                        <option [value]="status.Value">
                            <div class="row">
                                <div class="col">{{status.Name}}</div>
                            </div>
                        </option>
                        }
                    </select>
                    <div class="invalid-feedback">
                        Please select leave type!
                    </div>
                </div>
                <div class="col"></div>
                <div class="col-md-auto mt-4">
                    <button type="submit" class="btn btn-primary" [disabled]="isDisabled">
                        <i class="bi bi-search" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Search':'Loading...'}}
                    </button>
                </div>
            </div>
        </form>
        <div>
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">#</th>
                        <th>View</th>
                        <th style="width: 300px;">{{common.ToLowerCase(user.EmpType) == 'front'?'Client
                            Location':common.ToLowerCase(user.EmpType) == 'back'?'Branch':''}}</th>
                        <th>Attendance Date</th>
                        <th style="width: 100px;">In Time</th>
                        <th style="width: 100px;">Out Time</th>
                        <th style="width: 100px;">Remark</th>
                        <th style="width: 70px;">In Photo</th>
                        <th style="width: 90px;">Out Photo</th>
                        <th style="width: 130px;">Latitude/ Longitude</th>
                        <th style="width: 80px;">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let TableData of AttendanceHistory; let i = index">
                        <th scope="row" style="width: 5px;">{{i+1}}</th>
                        <td style="width: 5px;">
                            <div style="width: 80px;"><button type="button" class="btn btn-outline-primary btn-sm"
                                    [routerLink]="['/request/attendance/detail/',TableData['DailyAttendanceInOutID']]"><i
                                        class="bi bi-info-square me-1"></i>View</button></div>
                        </td>
                        <td style="width: 300px;">
                            <div style="width: 300px;">{{common.ToLowerCase(user.EmpType) ==
                                'front'?TableData['ClientLocation']:common.ToLowerCase(user.EmpType) ==
                                'back'?TableData['BranchName']:''}}</div>
                        </td>
                        <td>{{TableData['AttendanceDate'] | date : 'dd MMM yyyy' }}</td>
                        <td style="width: 100px;">
                            <div style="width:100px">{{TableData['InTime'] | date : 'dd MMM yyyy HH:mm:s' }}</div>
                        </td>
                        <td style="width: 100px;">
                            <div style="width:100px">{{TableData['OutTime'] | date : 'dd MMM yyyy HH:mm:s' }}</div>
                        </td>
                        <td style="width: 100px;">
                            {{TableData['AttendanceRemark']}}
                        </td>
                        <td style="width: 70px;">
                            <img *ngIf="TableData['DailyAttendancePhoto'] != null && TableData['DailyAttendancePhoto'] != ''"
                                (click)="common.FullImage(common.PhotoLink(TableData['DailyAttendancePhoto'],true),{ProfileImage :common.PhotoLink(user.EPhoto), Name:user.UserName,Code:'',Designation:user.EDesignation, MTitle1:'In Date', MTitle2:'In Time',MData1: TableData['InTime'], MData2:TableData['InTime']})"
                                mat-card-image class="userImage"
                                [src]="common.PhotoLink(TableData['DailyAttendancePhoto'],true)" />
                            <div *ngIf="TableData['DailyAttendancePhoto'] == null || TableData['DailyAttendancePhoto'] == ''"
                                (click)="common.FullImage(common.PhotoLink(TableData['DailyAttendancePhoto'],true),{ProfileImage :common.PhotoLink(user.EPhoto), Name:user.UserName,Code:'',Designation:user.EDesignation, MTitle1:'In Date', MTitle2:'In Time',MData1: TableData['InTime'], MData2:TableData['InTime']})"
                                class="initial-image">
                                <div class="image">
                                    {{common.getInitial(user.UserName)}}
                                </div>
                            </div>
                        </td>
                        <td style="width: 90px;">
                            <img *ngIf="TableData['DailyAttendancePhotoOut'] != null && TableData['DailyAttendancePhotoOut'] != ''"
                                (click)="common.FullImage(common.PhotoLink(TableData['DailyAttendancePhotoOut'],true),{ProfileImage :common.PhotoLink(user.EPhoto), Name:user.UserName,Code:'',Designation:user.EDesignation, MTitle1:'Out Date', MTitle2:'Out Date',MData1: TableData['OutTime'], MData2:TableData['OutTime']})"
                                mat-card-image class="userImage"
                                [src]="common.PhotoLink(TableData['DailyAttendancePhoto'],true)" />
                            <div *ngIf="TableData['DailyAttendancePhotoOut'] == null || TableData['DailyAttendancePhotoOut'] == ''"
                                (click)="common.FullImage(common.PhotoLink(TableData['DailyAttendancePhotoOut'],true),{ProfileImage :common.PhotoLink(user.EPhoto), Name:user.UserName,Code:'',Designation:user.EDesignation, MTitle1:'Out Date', MTitle2:'Out Date',MData1: TableData['OutTime'], MData2:TableData['OutTime']})"
                                class="initial-image">
                                <div class="image">
                                    {{common.getInitial(user.UserName)}}
                                </div>
                            </div>
                        </td>
                        <td style="width: 130px;">
                            <div style="width: 130px;">
                                <a href="https://www.google.com/maps/search/?api=1&query={{TableData['Latitude']}},{{TableData['Longitude']}}"
                                    target="_blank">{{'Lat : ' + TableData['Latitude'] }} <br /> {{'Lon : ' +
                                    TableData['Longitude'] }}</a>
                            </div>
                        </td>
                        <td style="width: 80px;"><span class="badge"
                                [ngClass]="{'success':common.ToLowerCase(TableData['ApprovalStatus']) == 'approved', 'warning':common.ToLowerCase(TableData['ApprovalStatus']) == 'pending','danger':common.ToLowerCase(TableData['ApprovalStatus']) == 'rejected'}">{{TableData['ApprovalStatus']}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>

    </div>


</div>